import { ExtendedContainer, ExtendedSprite, Layout } from "@aceroll/core";
import { ProgressScreen } from '../gameObjects';

export default class Progress extends Layout {
    init() {
        super.init();

        this.bgContainer = new ExtendedContainer('bgContainer');
        this.bgContainer.scaleMode = 'max';
        this.background = ExtendedSprite.fromAlias('img-preloader_background');
        this.background.anchor.set(0.5, 0.5);
        this.bgContainer.addChild(this.background);

        this.progressScreen = new ProgressScreen();
        this.gameContainer = new ExtendedContainer('gameContainer');
        this.gameContainer.addChild(this.progressScreen);

        this.root.addChild(
            this.bgContainer,
            this.gameContainer
        );
    }

    onLandscape() {
        this.background.position.set(960, 540);
        this.progressScreen.position.set(960, 540);
    }

    onPortrait() {
        this.background.position.set(540, 960);
        this.progressScreen.position.set(540, 960);
    }

    destroy() {
        this.progressScreen.hide();
        this.root.destroy({ children: true });
    }
}

